export default __webpack_public_path__ + "static/media/expired.0ebc7267.png";